import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{ padding: 24, textAlign: "center" }}>
          <h2 className="h2">Что-то сломалось</h2>
          <p className="body" style={{ color: "var(--fg2)", marginTop: 8 }}>
            Попробуй перезагрузить приложение.
          </p>
          <button
            onClick={this.reset}
            style={{
              marginTop: 16,
              padding: "12px 20px",
              borderRadius: 999,
              border: 0,
              background: "var(--brand-orange)",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Повторить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
